import React, { Component } from 'react'
import { connect } from 'react-redux'
import PreAuthSample from '../samples/PreAuthSample'
import { makePreauth } from '../../../actions/mcpActions'
import { updateOrderId } from '../../../actions/commonActions'
import { _MCP, _DOTNET, _JAVA, _PHP } from '../../../actions/types'

const CODES = {
    store_ID: ["mpgReq.SetStoreId(store_id);", "mpgReq.setStoreId(store_id);", "'store_id'=>$store_id"],
    API_token: ["mpgReq.SetApiToken(api_token);", "mpgReq.setApiToken(api_token);", "'api_token'=>$api_token"],
    
    order_ID: ["mcpPreauth.SetOrderId(order_id);", "mcpPreauth.setOrderId(order_id);", "'order_id'=>$order_id"],
    credit_card_number: ["mcpPreauth.SetPan(pan);", "mcpPreauth.setPan(pan);", "'pan'=>$pan"],
    expiry_date: ["mcpPreauth.SetExpdate(expiry_date);", "mcpPreauth.setExpDate(expiry_date);", "'expiry_date'=>$expiry_date"],
    electronic_commerce_indicator: ["mcpPreauth.SetCryptType(crypt);", "mcpPreauth.setCryptType(crypt);", "'crypt_type'=>$crypt"],
    
    version_number: ["mcpPreauth.SetMCPVersion(\"MCP_VERSION_NUM\");", "mcpPreauth.setMCPVersion(\"MCP_VERSION_NUM\");", "'mcp_version'=> $mcp_version"],
    cardholder_amount: ["mcpPreauth.SetCardholderAmount(\"CARDHOLDER_AMOUNT\");", "mcpPreauth.setCardholderAmount(\"CARDHOLDER_AMOUNT\");", "'cardholder_amount' => $cardholder_amount"],
    cardholder_currency_code: ["mcpPreauth.SetCardholderCurrencyCode(\"CARDHOLDER_CURRENCY_CODE\");", "mcpPreauth.setCardholderCurrencyCode(\"CARDHOLDER_CURRENCY_CODE\");", "'cardholder_currency_code' => $cardholder_currency_code"],

    customer_ID: ["mcpPreauth.SetCustId(cust_id);", "mcpPreauth.setCustId(cust_id);", "'cust_id'=>$cust_id"],
    dynamic_descriptor: ["mcpPreauth.SetDynamicDescriptor(dynamic_descriptor);", "mcpPreauth.setDynamicDescriptor(dynamic_descriptor);", "'dynamic_descriptor'=>$dynamic_descriptor"],
    wallet_indicator: ["mcpPreauth.SetWalletIndicator(wallet_indicator);", "mcpPreauth.setWalletIndicator(wallet_indicator);", "'wallet_indicator'=>$wallet_indicator"],
    final_authorization: ["mcpPreauth.SetFinalAuth(\"true\");", "mcpPreauth.setFinalAuth(\"true\");", "'final_auth' => ‘true’"],
    Credential_Info: ["mcpPreauth.SetCofInfo(cof);", "mcpPreauth.setCofInfo(cof);", "$mpgTxn->setCofInfo($cof);"],
    AVS_Information: ["mcpPreauth.SetAvsInfo(avsCheck);", "mcpPreauth.setAvsInfo(avsCheck);", "$mpgTxn->setAvsInfo($mpgAvsInfo);"],
    CVD_Information: ["mcpPreauth.SetCvdInfo(cvdCheck);", "mcpPreauth.setCvdInfo(cvdCheck);", "$mpgTxn->setCvdInfo($mpgCvdInfo);"],
    
    rate_token: ["mcpPreauth.SetMCPRateToken(\"MCP_RATE_TOKEN\");", "mcpPreauth.setMCPRateToken(\"MCP_RATE_TOKEN\");", "'mcp_rate_token' => $mcp_rate_token"],
}


export class PreAuth extends Component {
    async generateOrderId() {
        const d = new Date();
        var orderId = "Test";
        orderId += d.getFullYear().toString();
        orderId += d.getMonth().toString();
        orderId += d.getDay().toString();
        orderId += d.getHours().toString();
        orderId += d.getMinutes().toString();
        orderId += d.getSeconds().toString();
        return orderId;
    }

    async onMakePreAuthPress() {
        const newOrderId = await this.generateOrderId();
        this.props.updateOrderId({ featureId: _MCP, orderId: newOrderId });
        const { storeId, apiToken, pan, expdate, amount, currency, mcpRateToken } = this.props;
        const preAuthRequest = { storeId, apiToken, orderId: newOrderId, pan, expdate, amount, currency, mcpRateToken };
        this.props.makePreauth(preAuthRequest);
    }

    renderIntegrationTool() {
        return(
            <div className="stepMainContainer">
                <h3>Sample MCP Pre-Authorization</h3>
                <PreAuthSample />
                <div className="requestButton" onClick={() => this.onMakePreAuthPress()}>
                    MCP Pre-Authorization Request
                </div> 
            </div>
        );
    }

    renderDocument() {
        const { progLangId } = this.props;

        return (
            <div className="stepPageContainer">
                <span className="stepPageTitle"><b>MCP Pre-Authorization</b></span>
                <p style={{marginTop: '3vh'}}>Verifies and locks funds on the customer’s credit card. The funds are locked for a specified amount of
                    time based on the card issuer.To retrieve the funds that have been locked by a Pre-Authorization transaction
                    so that they may be settled in the merchant’s account, a Pre-Authorization Completion transaction
                    must be performed. A Pre-Authorization transaction may only be "completed" once.
                </p>
                <p>This transaction request is the multi-currency pricing (MCP) enabled version of the equivalent financial transaction.</p>
                

                <p><b>MCP Pre-Authorization transaction object definition</b></p>
                {(() => {
                switch(progLangId) {
                    case _DOTNET:
                        return  <code>MCPPreAuth mcpPreauth = new MCPPreAuth();</code>
                    case _JAVA:
                        return <code>MCPPreAuth mcpPreauth = new MCPPreAuth();</code>
                    case _PHP:
                        return <code>$txnArray = array(‘type’=>’mcp_preauth', …);<br />$mpgTxn = new mpgTransaction($txnArray);</code>
                    default:
                        return null
                    }
                })()}

                <p style={{ marginTop: '5vh'}}><b>HttpsPostRequest object for MCP Pre-Authorization transaction</b></p>
                {(() => {
                switch(progLangId) {
                    case _DOTNET:
                        return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.SetTransaction(mcpPreauth);</code>
                    case _JAVA:
                        return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.setTransaction(mcpPreauth);</code>
                    case _PHP:
                        return <code>$mpgRequest = new mpgRequest($mpgTxn);<br />$mpgHttpPost = new mpgHttpsPost($store_id,$api_token,$mpgRequest);</code>
                    default:
                        return null
                    }
                })()}

                <h3 style={{ marginTop: '7vh'}}>Core connection object fields (all API transactions)</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>store ID</td>
                        <td><i>String</i><br /><br /> N/A</td>
                        <td><code>{CODES.store_ID[progLangId]}</code></td>
                    </tr>

                    <tr>
                        <td>API token</td>
                        <td><i>String</i><br /><br /> N/A</td>
                        <td><code>{CODES.API_token[progLangId]}</code></td>
                    </tr>
                </table>

                <h3 style={{ marginTop: '7vh'}}>MCP Pre-Authorization transaction request fields – Required</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>order ID</td>
                        <td><i>String</i><br /><br />50-character alphanumeric</td>
                        <td><code>{CODES.order_ID[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>credit card number</td>
                        <td><i>String</i><br /><br />max 20-character alphanumeric</td>
                        <td><code>{CODES.credit_card_number[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>expiry date</td>
                        <td><i>String</i><br /><br />4-character alphanumeric<br />(YYMM format)</td>
                        <td><code>{CODES.expiry_date[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>electronic commerce indicator</td>
                        <td><i>String</i><br /><br />1-character alphanumeric</td>
                        <td><code>{CODES.electronic_commerce_indicator[progLangId]}</code></td>
                    </tr>
                </table>

                <h3 style={{ marginTop: '7vh'}}>MCP-specific request fields – Required</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>MCP version number</td>
                        <td><i>String</i><br /><br />numeric<br /><br />current version is 1.0</td>
                        <td><code>{CODES.version_number[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>cardholder amount</td>
                        <td><i>String</i><br /><br />12-character numeric<br /><br />smallest discrete unit of foreign currency</td>
                        <td><code>{CODES.cardholder_amount[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>cardholder currency code</td>
                        <td><i>String</i><br /><br />3-character numeric</td>
                        <td><code>{CODES.cardholder_currency_code[progLangId]}</code></td>
                    </tr>
                </table>
                
                <h3 style={{ marginTop: '7vh'}}>MCP Pre-Authorization transaction request fields – Optional</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>customer ID</td>
                        <td><i>String</i><br /><br />50-character alphanumeric<p className="note"><b>NOTE: </b> {"Some special characters are not allowed: < > $ % = ? ^ { } [ ] \\"}</p></td>
                        <td><code>{CODES.customer_ID[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>dynamic descriptor<p className="note"><b>NOTE: </b> For Pre-Authorization
                                                                                transactions: the value in the
                                                                                dynamic descriptor field will
                                                                                only be carried over to a Pre-
                                                                                Authorization Completion
                                                                                when executing the latter via
                                                                                the Merchant Resource
                                                                                Center; otherwise, the value
                                                                                for dynamic descriptor must
                                                                                be sent again in the Pre-
                                                                                Authorization Completion</p></td>
                        <td><i>String</i><br /><br />20-character alphanumeric<br /><br />total of 22 characters including your merchant name and separator<p className="note"><b>NOTE: </b> {"Some special characters are not allowed: < > $ % = ? ^ { } [ ] \\"}</p></td>
                        <td><code>{CODES.dynamic_descriptor[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>wallet indicator<br /><br /><p className="note"><b>NOTE: </b> For basic Purchase and Preauthorization, the wallet indicator applies to Visa Checkout and MasterCard MasterPass only. For more, see Definition of Request Fields.</p></td>
                        <td><i>String</i><br /><br />3-character alphanumeric</td>
                        <td><code>{CODES.wallet_indicator[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>final authorization<br /><br /><p className="note"><b>NOTE: </b>Applies to Mastercard transactions only</p></td>
                        <td><i>String</i><br /><br />true/false</td>
                        <td><code>{CODES.final_authorization[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>Credential on File Info<br />cof<br /><br /><p className="note"><b>NOTE: </b>This is a nested object within the transaction, and required when storing or using the customer's stored credentials. For information about fields in the Credential on FIle Info object, see Credential on File Info Object and Variables.</p></td>
                        <td><i>Object</i><br /><br />N/A</td>
                        <td><code>{CODES.Credential_Info[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>AVS Information</td>
                        <td><i>Object</i><br /><br />N/A</td>
                        <td><code>{CODES.AVS_Information[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>CVD Information<br /></td>
                        <td><i>Object</i><br /><br />N/A</td>
                        <td><code>{CODES.CVD_Information[progLangId]}</code></td>
                    </tr>
                </table>

                <h3 style={{ marginTop: '7vh'}}>MCP-specific request fields – Optional</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>MCP rate token</td>
                        <td><i>String</i><br /><br />N/A</td>
                        <td><code>{CODES.rate_token[progLangId]}</code></td>
                    </tr>
                </table>

            </div>
        )
    }

    render() {
        const { mode } = this.props;
        if(mode === 'interactive_tool')
            return this.renderIntegrationTool();
        else if(mode === 'integration_guide')
            return this.renderDocument();
        else {
            return null;
        }
    }
}

const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    const { storeId, apiToken, orderId, pan, expdate, amount, currency, mcpRateToken } = state.mcp.main.config;
    return { mode, storeId, apiToken, orderId, pan, expdate, amount, currency, mcpRateToken, progLangId: state.common.progLangList.selection };
}

export default connect(mapStateToProps, {makePreauth, updateOrderId})(PreAuth)
